// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DFhQ2","leftArrow":"styles_leftArrow__LaHOJ","rightArrow":"styles_rightArrow__iQ7ZA","todayButton":"styles_todayButton__skL2M"};